<template>
  <v-card class="show supervisor" v-if="supervisor">
    <v-card-title primary-title>
      <div>
        <div class="headline">Experience Verification</div>
        <span class="subheading grey--text">{{ experience.organization.name }}</span>
      </div>
    </v-card-title>

    <v-divider />
    <table class="v-table theme--dark">
      <tbody>
        <tr>
          <th class="text-xs-right">Name</th>
          <td>{{ supervisor.name }}</td>
        </tr>
        <tr>
          <th class="text-xs-right">Position</th>
          <td>{{ supervisor.position }}</td>
        </tr>
        <tr>
          <th class="text-xs-right">Email</th>
          <td>{{ supervisor.email }}</td>
        </tr>
        <tr v-if="supervisor.verificationSentAt">
          <th class="text-xs-right">Notified</th>
          <td>
            {{ new Date(supervisor.verificationSentAt) | date('h:mm a, MMMM do yyyy') }}
            ({{ new Date(supervisor.verificationSentAt) | inWords({ addSuffix: true }) }})
          </td>
        </tr>
        <tr v-if="supervisor.verifiedAt">
          <th class="text-xs-right">Verified</th>
          <td>
            {{ new Date(supervisor.verifiedAt) | date('h:mm a, MMMM do yyyy') }}
            ({{ new Date(supervisor.verifiedAt) | inWords({ addSuffix: true }) }})
          </td>
        </tr>
      </tbody>
    </table>
    <v-divider />

    <v-card-actions>
      <v-spacer />
      <can I="delete" a="Supervisor" v-if="!supervisor.verifiedAt">
        <v-dialog v-model="dialog" lazy absolute max-width="600">
          <v-btn flat color="error" slot="activator">Delete</v-btn>

          <v-card>
            <v-card-title>
              <div class="headline">Are you sure?</div>
            </v-card-title>
            <v-card-text>
              <p>
                This action cannot be undone and will remove this supervisor from the experience
                record.
              </p>
            </v-card-text>
            <v-card-actions
              ><v-spacer />
              <v-btn color="grey" flat @click="dialog = false">cancel</v-btn>
              <v-btn color="error" @click="destroy">Delete</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </can>
      <can I="update" a="Supervisor">
        <v-btn color="primary" @click="$emit('edit')">
          <v-icon left>mdi-pencil</v-icon> Edit
        </v-btn>
      </can>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: {
    supervisor: Object,
    experience: Object,
  },
  data() {
    return {
      dialog: false,
    }
  },
  methods: {
    destroy() {
      this.$store
        .dispatch('admin/supervisors/destroy', {
          id: this.supervisor.id,
          experienceId: this.experience.id,
        })
        .then(() => {
          this.$emit('refresh')
        })
    },
  },
}
</script>
